import { Address, AddressId } from './types'

// Sydney is the only office — it carries the full postal address and is the
// one NAP string published anywhere. The rest are cities our engineers work
// from and where we meet clients; publishing street addresses for them put
// six phantom locations into the entity graph.
export const ADDRESS_ITEMS: Record<AddressId, Address> = {
  [AddressId.Headquarters]: {
    id: AddressId.Headquarters,
    title: 'Headquarters:',
    caption: 'Suite 302, 13/15 Wentworth ave, Sydney NSW 2000, Australia',
  },
  [AddressId.London]: {
    id: AddressId.London,
    title: 'London',
    caption: 'United Kingdom',
  },
  [AddressId.Lisbon]: {
    id: AddressId.Lisbon,
    title: 'Lisbon',
    caption: 'Portugal',
  },
  [AddressId.Warsaw]: {
    id: AddressId.Warsaw,
    title: 'Warsaw',
    caption: 'Poland',
  },
  [AddressId.Wroclaw]: {
    id: AddressId.Wroclaw,
    title: 'Wrocław',
    caption: 'Poland',
  },
  [AddressId.Dnipro]: {
    id: AddressId.Dnipro,
    title: 'Dnipro',
    caption: 'Ukraine',
  },
  [AddressId.Odessa]: {
    id: AddressId.Odessa,
    title: 'Odessa',
    caption: 'Ukraine',
  },
  [AddressId.Kyiv]: {
    id: AddressId.Kyiv,
    title: 'Kyiv',
    caption: 'Ukraine',
  },
}
